/* VANDJI - personnalisations JS. Charge depuis layout/theme.liquid. */

window.VANDJI_CUSTOM = (function () {
  'use strict';

  /* ================================================================
     1. Note moyenne du widget d'avis Judge.me

     Judge.me arrondit la note du widget de bas de page a une decimale
     ("5.0") alors que le badge en haut de fiche affiche la valeur exacte
     ("4.95"). Meme donnee, deux arrondis : effet "deux notes differentes".
     Aucun reglage pour ca dans le bloc Judge.me, et le CSS ne peut pas
     reecrire du texte -> on realigne le widget sur la valeur exacte, lue
     dans l'aria-label de ses propres etoiles ("4.95 out of 1 stars").
     Aucune donnee inventee : on supprime seulement l'arrondi.
     ================================================================ */

  var RATING_IN_LABEL = /(\d+(?:[.,]\d+)?)\s+out of/i;
  var LOOKS_NUMERIC = /^\d+([.,]\d+)?$/;
  var ratingRunning = false;

  function syncRating() {
    if (ratingRunning) return 0;
    ratingRunning = true;
    var changed = 0;

    try {
      var displays = document.querySelectorAll('.jm-average-rating-display');

      for (var i = 0; i < displays.length; i++) {
        var display = displays[i];
        var stars = display.querySelector('.jm-star-rating[aria-label]');
        if (!stars) continue;

        var match = RATING_IN_LABEL.exec(stars.getAttribute('aria-label') || '');
        if (!match) continue;

        var exact = match[1];
        var texts = display.querySelectorAll('.jm-text');

        for (var j = 0; j < texts.length; j++) {
          var current = texts[j].textContent.trim();
          if (!LOOKS_NUMERIC.test(current)) continue;
          if (current !== exact) {
            texts[j].textContent = exact;
            changed++;
          }
          break;
        }
      }
    } finally {
      ratingRunning = false;
    }

    return changed;
  }

  /* ================================================================
     2. Estimation de livraison sur la fiche produit

     Regle, parametrable par data-attribut dans le bloc Liquid :
     - le colis part a 10h (data-cutoff-hour), du lundi au vendredi ;
     - commande avant 10h -> depart le jour meme ;
     - commande apres 10h -> depart au prochain jour ouvre a 10h ;
     - livraison = depart + N a M jours ouvres (data-transit-min / max).

     Tout est calcule dans le fuseau de la boutique (data-timezone) et non
     dans celui du visiteur : un client au Canada voit le meme cut-off.
     Les jours feries ne sont PAS pris en compte.

     data-note (facultatif) ajoute une phrase en italique sous l'estimation,
     dans le meme encadre. Elle DOIT passer par cet attribut : le JS reecrit
     tout le contenu du div a chaque rafraichissement du compte a rebours
     (toutes les 30 s), donc du texte ecrit en dur dans le bloc Liquid
     serait efface au bout de 30 secondes.

     Le mois est affiche en toutes lettres ("29 juillet") et non abrege :
     "juil." se terminant par un point, on obtenait "juil.." avant le point
     de fin de phrase.
     ================================================================ */

  function zonedParts(date, tz) {
    var fmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: tz,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23'
    });
    var out = {};
    fmt.formatToParts(date).forEach(function (p) {
      if (p.type !== 'literal') out[p.type] = parseInt(p.value, 10);
    });
    return out;
  }

  /* On manipule des dates "civiles" construites en UTC : les calculs de
     jours et les differences restent justes tant qu'on reste dans ce repere. */
  function toCivil(p) {
    return new Date(Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second));
  }

  function addDays(date, n) {
    var d = new Date(date.getTime());
    d.setUTCDate(d.getUTCDate() + n);
    return d;
  }

  function isBusinessDay(date) {
    var day = date.getUTCDay();
    return day !== 0 && day !== 6;
  }

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    var left = n;
    while (left > 0) {
      d = addDays(d, 1);
      if (isBusinessDay(d)) left--;
    }
    return d;
  }

  function formatDay(date) {
    return new Intl.DateTimeFormat('fr-FR', {
      weekday: 'short', day: 'numeric', month: 'long', timeZone: 'UTC'
    }).format(date);
  }

  function formatCountdown(ms) {
    var minutes = Math.max(0, Math.floor(ms / 60000));
    var days = Math.floor(minutes / 1440);
    var hours = Math.floor((minutes % 1440) / 60);
    var mins = minutes % 60;
    if (days > 0) return days + ' j ' + hours + ' h ' + mins + ' min';
    return hours + ' h ' + mins + ' min';
  }

  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function renderDelivery(el) {
    var tz = el.getAttribute('data-timezone') || 'Europe/Paris';
    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    var transitMin = parseInt(el.getAttribute('data-transit-min'), 10);
    var transitMax = parseInt(el.getAttribute('data-transit-max'), 10);
    var note = el.getAttribute('data-note');

    if (isNaN(cutoffHour)) cutoffHour = 10;
    if (isNaN(transitMin)) transitMin = 2;
    if (isNaN(transitMax)) transitMax = 3;

    var parts = zonedParts(new Date(), tz);
    var now = toCivil(parts);

    /* prochain depart : aujourd'hui a 10h si on est encore avant,
       sinon le prochain jour ouvre a 10h */
    var dispatch = new Date(Date.UTC(parts.year, parts.month - 1, parts.day, cutoffHour, 0, 0));
    if (now.getTime() >= dispatch.getTime()) dispatch = addDays(dispatch, 1);
    while (!isBusinessDay(dispatch)) dispatch = addDays(dispatch, 1);

    var first = addBusinessDays(dispatch, transitMin);
    var last = addBusinessDays(dispatch, transitMax);
    var countdown = formatCountdown(dispatch.getTime() - now.getTime());

    var range = (first.getTime() === last.getTime())
      ? 'le <strong>' + formatDay(first) + '</strong>'
      : 'entre <strong>' + formatDay(first) + '</strong> et <strong>' + formatDay(last) + '</strong>';

    var html = 'Recevez votre commande ' + range +
      '. Commandez dans les <strong>' + countdown + '</strong>.';

    if (note) {
      html += '<br><em class="vandji-delivery-note">' + escapeHtml(note) + '</em>';
    }

    el.innerHTML = html;
    el.removeAttribute('hidden');
  }

  function syncDelivery() {
    var els = document.querySelectorAll('[data-vandji-delivery]');
    for (var i = 0; i < els.length; i++) {
      try { renderDelivery(els[i]); } catch (e) { /* on laisse le bloc masque */ }
    }
    return els.length;
  }

  /* ================================================================
     3. Liens vers la cabine d'essayage (room.vandjicase.com)

     L'editeur de menu Shopify ne propose pas "ouvrir dans un nouvel
     onglet" : un lien de navigation fait donc quitter la boutique.
     On pose target="_blank" sur tous les liens qui pointent vers le
     sous-domaine room, ou qu'ils soient (menu desktop, menu mobile,
     footer, bouton dans une page). rel="noopener noreferrer" empeche
     la page ouverte d'agir sur la boutique via window.opener.

     Le menu mobile est injecte apres le chargement dans certains cas :
     la fonction est donc rejouee par le MutationObserver et le polling
     de demarrage ci-dessous. Le :not([target]) la rend idempotente et
     evite d'ecraser un lien qui aurait deja son propre target.
     ================================================================ */

  var NEW_TAB_SELECTOR = 'a[href*="room.vandjicase.com"]:not([target])';

  function syncNewTabLinks() {
    var links = document.querySelectorAll(NEW_TAB_SELECTOR);

    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('target', '_blank');
      links[i].setAttribute('rel', 'noopener noreferrer');
      /* message lecteur d'ecran deja present dans layout/theme.liquid */
      links[i].setAttribute('aria-describedby', 'a11y-new-window-message');
    }

    return links.length;
  }

  /* ================================================================
     4. Position du selecteur d'accessoire ProductWiz (.rio-options)

     Sur les fiches accessoires, l'app ProductWiz injecte elle-meme son
     selecteur ("Choisissez votre accessoire") en PREMIER enfant de
     <product-info> : il se retrouve au-dessus du fil d'ariane et du
     titre. Ce n'est pas un bloc du template, il n'apparait donc pas
     dans l'editeur de theme et son ordre n'y est pas reglable.

     On le replace juste apres la description, avant les bundles, a la
     meme place que le selecteur de variante des autres fiches.
     Idempotent : si la description precede deja le selecteur, on ne
     touche a rien - indispensable car la fonction est rejouee par le
     MutationObserver, que notre propre deplacement declenche.
     ================================================================ */

  function syncRioOptionsPlacement() {
    var rio = document.querySelector('product-info > .rio-options');
    if (!rio) return 0;

    var description = rio.parentElement.querySelector(':scope > .product__text');
    if (!description || description.nextElementSibling === rio) return 0;

    description.after(rio);
    return 1;
  }

  /* ================================================================
     Demarrage. Le widget Judge.me est une app Vue qui arrive apres la
     page et se redessine : MutationObserver + court polling de securite.
     ================================================================ */

  function start() {
    syncRating();
    syncDelivery();
    syncNewTabLinks();
    syncRioOptionsPlacement();

    if (typeof MutationObserver === 'function') {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        setTimeout(function () {
          scheduled = false;
          syncRating();
          syncNewTabLinks();
          syncRioOptionsPlacement();
        }, 60);
      }).observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    var ticks = 0;
    var boot = setInterval(function () {
      syncRating();
      syncDelivery();
      syncNewTabLinks();
      syncRioOptionsPlacement();
      if (++ticks > 60) clearInterval(boot);
    }, 500);

    /* le compte a rebours se rafraichit toutes les 30 s */
    setInterval(syncDelivery, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  return {
    version: 7,
    syncRating: syncRating,
    syncDelivery: syncDelivery,
    syncNewTabLinks: syncNewTabLinks,
    syncRioOptionsPlacement: syncRioOptionsPlacement
  };
})();